$(() => {
    function registerGewinnSlider() {
        let $winnerSlider = $('#past-winner-slider');
        let $slideTemplate = $winnerSlider.find('.gewinn').first().clone();
        $slideTemplate.find('.gewinn__mystery').remove();
        let reachedEnd = false;

        $winnerSlider.flexslider({
            animation: 'slide',
            animationLoop: false,
            controlNav: false,
            itemWidth: 210,
            itemMargin: 5,
            slideshow: false,
            after: function (slider) {
                // Wir können nur mit Template anhängen,
                // entsprechend muss hier ggf. weggeschalten werden.
                if ($slideTemplate.length === 0 || reachedEnd) {
                    return;
                }

                let offset = $winnerSlider.find('.gewinn').length;
                let fetchCount = 5;
                let $loading = $(
                    '<li class="aligncenter">' +
                    '   <span style="margin-top: 50%" class="fa fa-4x fa-spin fa-spinner"></span>' +
                    '</li>'
                );
                $.ajax({
                    url: domain + '/ajax/verlosteGewinne.php?offset=' + offset + '&count=' + fetchCount
                }).done((data) => {
                    if (data.length < fetchCount) {
                        reachedEnd = true;
                    }

                    //fetchCount
                    data.forEach((gewinn) => {
                        gewinn.bild = gewinn.bild.replace('https://', 'http://');

                        let $slide = $slideTemplate.clone();

                        $slide.attr('data-slide-id', gewinn.id);

                        $slide.find('.gewinn__bild')
                            .attr('src', gewinn.bild)
                            .attr('alt', gewinn.name);

                        $slide.find('.gewinn__spieler')
                            .attr('href', domain + '/spieler/' + gewinn.nickname + '/')
                            .find('strong')
                            .text(gewinn.nickname);

                        $slide.find('.gewinn__wann')
                            .text(gewinn.ende);

                        if (gewinn.nummer.match(/MYSTERY/)) {
                            $slide.append('<p class="gewinn__mystery">(Mystery Gewinn)</p>');
                        }

                        slider.addSlide($slide);
                    });

                    // remove ajax spinner
                    //slider.removeSlide($loading);

                    // Fix optical juggling
                    slider.resize();
                });
            }
        });
    }

    function registerAchievement() {
        $('.achievement__container').each((idx, val) => {
            let container = $(val);
            let checkInterval = container.data('interval');
            let displayDuration = container.data('duration');
            let autostart = container.data('duration') ? container.data('duration') : true;

            let achievement = new AchievementContainer(
                container,
                domain + '/ajax/checkTrophy.php',
                (checkInterval ? checkInterval : 10) * 1000,
                (displayDuration ? displayDuration : 2) * 1000
            );

            if (autostart) {
                achievement.startWatch();
            }
        });
    }

    function registerInfiniteScroll() {
        $('.infinite-scroll').jscroll({
            loadingHtml: '<p class="text-center"><span class="fa fa-spinner fa-spin fa-4x"></span><br/> Lade...</p>',
            padding: 20,
            nextSelector: 'a.jscroll-next:last',
            contentSelector: 'li',
            autoTriggerUntil: 5
        });
    }

    registerAchievement();
    registerGewinnSlider();
    registerInfiniteScroll();
});


// Imported from /js/main.js
// Owl Carousels
$(document).ready(function ($) {
    $("#main-spiele").owlCarousel({
        navigation: true,
        //autoPlay: 2000,
        autoPlay: false,
        stopOnHover: true,
        navigationText: ["", ""],
        rewindNav: true,
        scrollPerPage: false,
        pagination: false,
        paginationNumbers: false,
        items: 4
    });
});

$(document).ready(function ($) {
    // scroll body to 0px on click
    $('.back-top').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
        return false;
    });
});

// Tabs
$(document).ready(function ($) {
    $('#myTab a:first').tab('show');
});

$(window).load(function () {
    $('#featured-shop').flexslider({
        animation: "slide",
        controlNav: false,
        directionNav: true,
        start: function (slider) {
            $('body').removeClass('loading');
        }
    });
});

$(window).load(function () {
    $('#thumb-slider').flexslider({
        animation: "slide",
        directionNav: false,
        controlNav: "thumbnails",
        start: function (slider) {
            $('body').removeClass('loading');
        }
    });
});

$(function () {
    $('.tt').tooltip();
});

$(function(){
    var $dropdowns = $('.dropdown');
    $dropdowns.bind('mouseenter', function(){
        var $dropdown = $(this);

        if($dropdown.find('>.dropdown-toggle').length > 0)
        {
            $dropdown.addClass('open');
        }
    });
    $dropdowns.bind('mouseleave', function(){
        var $dropdown = $(this);

        if($dropdown.find('>.dropdown-toggle').length > 0)
        {
            if(!$dropdown.hasClass('open-fixed')) {
                $dropdown.removeClass('open');
            }
        }
    });
    $dropdowns.bind('click', function(e){

        var $dropdown = $(this);
        if($dropdown.attr('src') === '#')
            e.preventDefault();

        if($dropdown.hasClass('open-fixed'))
        {
            $dropdown.removeClass('open-fixed');
            $dropdown.removeClass('open');
        }else{
            $dropdown.addClass('open-fixed');
            $dropdown.addClass('open');
        }

    });

    var $faqs = $('#faqs');
    $faqs.find('.collapse.in').removeClass('in');
    $faqs.find(".fa-minus-square").removeClass("fa-minus-square").addClass("fa-plus-square");

    $faqs.find('.panel').bind('shown.bs.collapse', function () {
        $(this).find(".fa-plus-square").removeClass("fa-plus-square").addClass("fa-minus-square");
    });

    $faqs.find('.panel').bind('hidden.bs.collapse', function () {
        $(this).find(".fa-minus-square").removeClass("fa-minus-square").addClass("fa-plus-square");
    });
});
